interface CloudPaymentsOptions {
  yandexPaySupport: boolean;
  applePaySupport: boolean;
  googlePaySupport: boolean;
  masterPassSupport: boolean;
  tinkoffInstallmentSupport: boolean;
}

type CloudPaymentsPayAdditionalData = Partial<{
  firstName: string;
  lastName: string;
  middleName: string;
  birth: string;
  street: string;
  address: string;
  city: string;
  country: string;
  phone: string;
  postcode: string;
  comment: string;
}>;

export interface CloudPaymentsPayChargeData {
  CloudPayments: CloudPaymentsPayAdditionalData & {
    recurrent: {
      interval: 'Day' | 'Week' | 'Month' | string;
      period: number;
    };
  };
}

interface CloudPaymentsPayParams<T> {
  publicId: string;
  email?: string;
  accountId: string;
  description: string;
  amount: number;
  currency: string;
  invoiceId: string;
  data: T;
}

class CloudPayments {
  // biome-ignore lint/complexity/noUselessConstructor: skip
  constructor(_options: Partial<CloudPaymentsOptions>) {}

  /**
   * This method is used to pay for the subscription.
   * @param type
   * @param data
   */
  pay(_type: 'charge', _data: CloudPaymentsPayParams<CloudPaymentsPayChargeData>) {}

  oncomplete() {}
}

declare global {
  interface Window {
    cp: {
      CloudPayments: typeof CloudPayments;
    };
  }
}

export const useCloudPayments = () => {
  return new window.cp.CloudPayments({
    yandexPaySupport: false,
    applePaySupport: false,
    googlePaySupport: false,
    masterPassSupport: false,
    tinkoffInstallmentSupport: false,
  });
};
